import React, { useState } from "react";
import { Modal } from "@mui/material";
import modalStyles from "@/Theme/modalsElements.module.scss";
import BasicButton from "../../../../UI/BasicButton";
import { useAppSelector } from "../../../../Hooks/redux/useAppSelector";
import PaymentMethodsList from "./Components/PaymentMethodsList";
import { MakePaymentContainer } from "./styled";
import PaymentWalletModal from "./Modals/PaymentWalletModal";

const MakePaymentModule = () => {
  const [openWalletModal, setOpenWalletModal] = useState(false);
  const { user } = useAppSelector((state) => state.clientDataSlice);

  const handleOpenWalletModal = () => {
    setOpenWalletModal(true);
  };

  const handleCloseWalletModal = () => {
    setOpenWalletModal(false);
  };

  return (
    <MakePaymentContainer>
      <PaymentMethodsList />
      <BasicButton
        onClick={handleOpenWalletModal}
        size={"md"}
        text={"Make a payment"}
        variant={"blue"}
        disabled={user ? !user?.isVerify : true}
      />
      <Modal
        open={openWalletModal}
        onClose={handleCloseWalletModal}
        className={modalStyles.modal}
      >
        <PaymentWalletModal onClose={handleCloseWalletModal} />
      </Modal>
    </MakePaymentContainer>
  );
};

export default MakePaymentModule;
